import React, { Component } from 'react';
import CrcQualitySheetNews from './CrcQualitySheetNews';
import SeanceCalendar from './SeanceCalendar';
import WaitRelate from './WaitRelate';
import Backlog from './Backlog';
import NewsRemind from './NewsRemind';
import LeaveSituation from './LeaveSituation';
import CrcHandover from './CrcHandover';
import PmHandover from './PmHandover';

class AfficheNews extends Component {
    render() {
        const { curRole, isInvPM } = sessionStorage;
        return (
            <div className="tabWidth">
                <div className="flexBox">
                    <SeanceCalendar />
                    <Backlog />
                    <PmHandover />
                    {
                        (curRole === 'BO' || curRole === 'PM' || curRole === 'PML' || curRole === 'CRCC' || isInvPM === 'true') &&
                        <LeaveSituation />
                    }
                    {
                        (curRole === 'VP' || curRole === 'BO' || curRole === 'PM' || curRole === 'PML' || curRole === 'CRCM' || curRole === 'CRCC' || curRole === 'CRC') &&
                        <CrcHandover />
                    }
                    {
                        (curRole === 'BO' || curRole === 'PM' || curRole === 'PML' || curRole === 'CRC' || curRole === 'CRCC' || curRole === 'CRCM') &&
                        <WaitRelate />
                    }
                </div>
                <NewsRemind />
                <CrcQualitySheetNews />
            </div>
        );
    }
}

export default AfficheNews;


// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/index.js